<template>
  <section>
    <v-btn
      color="success"
      dark
      title="Notificar seleccionados"
      @click="abrirCerrarDialog()"
    >
      <v-icon>mail</v-icon>
      Notificar
    </v-btn>
    <v-dialog
      width="700"
      persistent
      v-model="dialog"
      transition="dialog-bottom-transition"
    >
      <v-card class="pb-2">
        <v-form v-model="valid" ref="form" lazy-validation>
          <!-- Cabecera del formulario -->
          <v-card-title class="headline">
            <v-flex xs9> <v-icon>mail</v-icon> ENVIAR CORREO </v-flex>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="abrirCerrarDialog()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-3">
            <v-layout row wrap justify-center>
              <v-flex shrink class="text-xs-center">
                <v-card
                  color="rgb(87,51,204,0.8)"
                  class="px-3 mb-2 white--text "
                >
                  <span class="caption">NOTIFICACIONES</span><br />
                  <span class="display-1">{{ lista_correos.length }}</span>
                </v-card>
              </v-flex>
              <v-flex xs12 class="pb-2" v-if="!disabled_notificaciones">
                <v-btn
                  class="p-0 m-0"
                  color="#0085AD"
                  @click="notificarCorreo(lista_correos)"
                  :loading="loading"
                  dark
                  block
                  title="Notificar faltas"
                >
                  <v-icon>mail</v-icon>
                  ENVIAR CORREO
                </v-btn>
              </v-flex>
              <v-flex xs12 v-if="sw_envio_correos">
                <h4 class="blue--text text-xs-center">
                  {{ contador_correos_enviados }} correos enviados de
                  {{ lista_correos.length }}
                </h4>
              </v-flex>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :headers="headers"
                  :items="lista_correos"
                  :no-data-text="
                    loading ? 'Cargando...' : 'No se tiene registros'
                  "
                  :loading="loading"
                  rows-per-page-text="Filas por pagina"
                  :rows-per-page-items="[5, 10, 20, 50]"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.nombres }}
                    </td>
                    <td class="text-xs-center">
                      <v-tooltip bottom color="indigo lighten-1">
                        <div slot="activator">
                          {{ props.item.correo }}
                        </div>
                        <div class="text-xs-center">
                          <span>{{ props.item.nombres }}</span>
                          <table>
                            <tr>
                              <th>Fecha</th>
                              <th>Descripción</th>
                              <th>Horario</th>
                              <th>Hora marcada</th>
                              <th>Falta</th>
                            </tr>
                            <tr
                              v-for="marcado in props.item.control_asistencia"
                              :key="marcado.id_persona"
                            >
                              <td style="width: 20%;">
                                {{
                                  $moment(marcado.fecha_marcado).format(
                                    "DD/MM/YYYY"
                                  )
                                }}
                              </td>
                              <td style="width: 20%;">
                                {{
                                  marcado.descripcion
                                    ? marcado.descripcion
                                    : "-"
                                }}
                              </td>
                              <td style="width: 20%;">
                                {{ marcado.horario ? marcado.horario : "-" }}
                              </td>
                              <td style="width: 20%;">
                                {{
                                  marcado.hora_marcada
                                    ? marcado.hora_marcada
                                    : "-"
                                }}
                              </td>
                              <td style="width: 20%;">
                                {{ marcado.detalle_marcado }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-if="correos_enviados.length > 0">
                <v-layout row wrap>
                  <v-flex shrink class="mr-2"
                    ><h3 class="blue--text">Enviados</h3></v-flex
                  >
                  <v-flex shrink>
                    <v-tooltip bottom>
                      <v-btn
                        color="green"
                        outline
                        icon
                        slot="activator"
                        @click="
                          crearExcel(
                            correos_enviados,
                            'NOTIFICACIONES ENVIADAS'
                          )
                        "
                      >
                        <span class="material-symbols-outlined">
                          table_view
                        </span>
                      </v-btn>
                      <span>Exportar Ecxel</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :headers="headers"
                  :items="correos_enviados"
                  :no-data-text="
                    loading ? 'Cargando...' : 'No se tiene registros'
                  "
                  :loading="loading"
                  rows-per-page-text="Filas por pagina"
                  :rows-per-page-items="[5, 10, 20, 50]"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.nombres }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.correo }}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 v-if="correos_fallidos.length > 0">
                <v-layout row wrap>
                  <v-flex shrink class="mr-2"
                    ><h3 class="blue--text">No Enviados</h3></v-flex
                  >
                  <v-flex shrink>
                    <v-tooltip bottom>
                      <v-btn
                        color="green"
                        outline
                        icon
                        slot="activator"
                        @click="
                          crearExcel(
                            correos_fallidos,
                            'NOTIFICACIONES NO ENVIADAS'
                          )
                        "
                      >
                        <span class="material-symbols-outlined">
                          table_view
                        </span>
                      </v-btn>
                      <span>Exportar Excel</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :headers="headers"
                  :items="correos_fallidos"
                  :no-data-text="
                    loading ? 'Cargando...' : 'No se tiene registros'
                  "
                  :loading="loading"
                  rows-per-page-text="Filas por pagina"
                  :rows-per-page-items="[5, 10, 20, 50]"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.nombres }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.correo }}
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
const XlsxPopulate = require("xlsx-populate");
export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  props: ["lista_correos", "parametros_notificacion"],
  // Definición de componentes importados
  components: {},
  // Variables iniciales del componente
  data() {
    return {
      user: this.$storage.get("user"),
      loading: false,
      valid: true,
      dialog: false,
      headers: [
        {
          text: "Nombre completo",
          value: "nombres",
          align: "center"
        },
        {
          text: "Correo",
          value: "correo",
          align: "center"
        }
      ],
      sw_envio_correos: false,
      contador_correos_enviados: 0,
      correos_enviados: [],
      correos_fallidos: [],
      disabled_notificaciones: false
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on("closeDialog", () => {});
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para cerrar o abrir el dialog
    abrirCerrarDialog() {
      this.contador_correos_enviados = 0;
      this.sw_envio_correos = false;
      this.dialog = this.dialog ? false : true;
      this.disabled_notificaciones = false;
    },
    // Metodo para exportar a un excel
    crearExcel(jsonData, titulo) {
      // Crear un nuevo libro de Excel
      XlsxPopulate.fromBlankAsync()
        .then(workbook => {
          const sheet = workbook.sheet(0);
          sheet
            .cell("A1")
            .style({
              fontSize: 18,
              bold: true,
              fontColor: "1D4F91"
            })
            .value(titulo);
          // Creamos cabecera
          let json_object = jsonData[0];
          var codigoAscii = 65; //LETRA A
          for (const key in json_object) {
            sheet
              .cell(`${String.fromCharCode(codigoAscii)}${2}`)
              .value(key.toUpperCase());
            codigoAscii++;
          }
          // Creamos cuerpo
          const data = jsonData.map(obj => Object.values(obj));
          sheet.cell("A3").value(data); // Datos
          return workbook.outputAsync();
        })
        .then(blob => {
          // Crear un nuevo Blob con el contenido del archivo Excel
          var fecha_descarga = this.$moment().format("DD_MM_YYYY");
          const excelBlob = new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.sp"
          });
          let url = window.URL.createObjectURL(excelBlob);
          let a = document.createElement("a");
          a.href = url;
          a.download = `${titulo}_${fecha_descarga}.xlsx`;
          document.body.appendChild(a);
          a.click();
        })
        .catch(error => {
          console.error("Error al crear el archivo Excel:", error);
        });
    },
    // Metodo para enviar los correos
    async notificarCorreo(lista_faltas) {
      this.$confirm("¿Está seguro de enviar los correos?", async () => {
        this.loading = true;
        this.sw_envio_correos = true;
        for (let index = 0; index < lista_faltas.length; index++) {
          const item = lista_faltas[index];
          // Generamos HTML tabla
          let tabla = this.generaTabla(item.control_asistencia);
          let mensaje = `
            <h1>NOTIFICACIÓN DE OBSERVACIONES EN EL REGISTRO DE ASISTENCIA</h1>
            <p>Sr(a).${item.nombres} </p>
            <p>Se comunica que usted ha incurrido en las siguientes faltas:</p>
            ${tabla}
            <br><br><br>
            <span style="color:rgba(2, 96, 202, 0.884)">De conformidad al parágrafo I, artículo 51 del Reglamento Interno de Personal Vigente y su modificación, su persona, a partir del día siguiente hábil de la presente notificación, deberá regularizar las observaciones realizadas (omisión, ausencia en el puesto de trabajo e inasistencia) en un plazo máximo 3 días, caso contrario se procederá a aplicar la sanción que corresponda.</span>
          `;
          let mensaje_texto = mensaje.replace(/<[^>]+>/g, "");

          let sw_envio = await this.$service.sendEmail({
            correo: item.correo,
            asunto:
              "NOTIFICACIÓN DE OBSERVACIONES EN EL REGISTRO DE ASISTENCIA",
            mensaje: mensaje_texto,
            html: mensaje
          });
          // Preguntamos si se envio del correo correctamente
          let data_notificacion = {
            id_persona: item.id_persona,
            nombres: item.nombres,
            correo: item.correo,
            faltas: this.parametros_notificacion.faltas,
            fecha_inicio: this.parametros_notificacion.fecha_inicio,
            fecha_fin: this.parametros_notificacion.fecha_fin,
            mensaje: mensaje_texto,
            fecha_notificacion: this.$moment().format("YYYY-MM-DD")
          };
          if (sw_envio) {
            this.correos_enviados.push(data_notificacion);
            // Guardamos historial de notificaciones
            await this.$query.add("historial_notificaciones", {
              id_persona: item.id_persona,
              faltas: this.parametros_notificacion.faltas,
              fecha_inicio: this.parametros_notificacion.fecha_inicio,
              fecha_fin: this.parametros_notificacion.fecha_fin,
              mensaje: mensaje,
              fecha_notificacion: new Date(),
              id_estado: 1,
              _user_created: this.user.id
            });
          } else {
            this.correos_fallidos.push(data_notificacion);
          }
          this.contador_correos_enviados++;
        }
        // LLamamos a actualizar el historial
        this.$bus.$emit("actualizaHistorialNotificacion");
        this.loading = false;
        this.disabled_notificaciones = true;
        // this.abrirCerrarDialog();
      });
    },
    generaTabla(faltas) {
      var cadena = "";
      faltas.forEach(element => {
        cadena += `
          <tr style="min-width: 100%;text-align: center;">
            <td style="width=16%">${this.$moment(element.fecha_marcado).format(
              "DD/MM/YYYY"
            )}</td>
            <td style="width=16%">${
              element.descripcion ? element.descripcion : "-"
            }</td>
            <td style="width=16%">${
              element.horario ? element.horario : "-"
            }</td>
            <td style="width=16%">${
              element.hora_marcada ? element.hora_marcada : "-"
            }</td>
            <td style="width=16%">${element.atraso ? element.atraso : "-"}</td>
            <td style="width=16%">${element.detalle_marcado}</td>
          </tr>
         `;
      });
      var estilo_header = `style="height: 1em !important;color: rgba(2, 96, 202, 0.884);font-weight: bold;font-size: 0.9em;border-bottom: 1px solid rgba(2, 69, 156, 0.274);padding: 0px 0.2em 0px 0.2em !important;"`;
      var tabla = `
        <table style="min-width: 100%;font-family: 'Arial', sans-serif;">
          <tr>
            <th ${estilo_header}> Fecha</th>
            <th ${estilo_header}> Descripción</th>
            <th ${estilo_header}> Horario</th>
            <th ${estilo_header}> Hora que marcó</th>
            <th ${estilo_header}> Atraso</th>
            <th ${estilo_header}> Falta</th>
          </tr>
          ${cadena}
        </table>
      `;
      return tabla;
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/components/EnviaCorreoMasivo.vue